import LegalLayout from '@/layouts/LegalLayout';

export default function Privacy() {
  return (
    <LegalLayout title="Privacy policy" updated="draft">
      <p>
        People tell companions things they have not told anyone. That places a heavier duty on us
        than a normal app, and this policy is written on that basis.
      </p>

      <h2>1. What we collect</h2>

      <h3>From members</h3>
      <ul>
        <li>Mobile number and the name you choose to display</li>
        <li>Date of birth, to confirm you are 18 or over</li>
        <li>Session metadata — who you spoke to, when, for how long, and what it cost</li>
        <li>Chat messages, where you use chat sessions</li>
        <li>Device and connection information, for security and call quality</li>
      </ul>

      <h3>From companions</h3>
      <ul>
        <li>Everything above, plus</li>
        <li>Legal name, PAN, and one government photo ID, for verification and tax</li>
        <li>Bank account details, to pay you</li>
      </ul>

      <h3>Payment information</h3>
      <p>
        <strong>We never see or store your card or UPI details.</strong> Payments are handled
        entirely by our payment gateway. We store only the amount, the time, and a reference number.
      </p>

      <h2>2. What we do not do</h2>
      <ul>
        <li>
          <strong>We do not record calls.</strong> Not by default, and never without telling both
          people first.
        </li>
        <li>
          <strong>We do not show your phone number to companions</strong>, or theirs to you.
        </li>
        <li>
          <strong>We do not sell your data</strong>, and we do not share it with advertisers.
        </li>
        <li>
          <strong>We do not use what you talk about to target advertising.</strong>
        </li>
      </ul>

      <h2>3. Why we hold it</h2>
      <ul>
        <li>To run the service — connect you, bill accurately, pay companions</li>
        <li>To keep people safe — investigate reports, act on abuse</li>
        <li>To meet legal obligations — tax, financial records, lawful requests</li>
        <li>To fix and improve the product, using aggregate figures rather than conversations</li>
      </ul>

      <h2>4. Who we share it with</h2>
      <p>Only the providers needed to run the service, and only what each one needs:</p>
      <ul>
        <li>
          <strong>Payment gateway</strong> — to take payments and pay out
        </li>
        <li>
          <strong>Cloud database and hosting</strong> — to store accounts and history
        </li>
        <li>
          <strong>Real-time calling provider</strong> — to carry audio and video
        </li>
        <li>
          <strong>Notification provider</strong> — to tell you about an incoming call
        </li>
      </ul>
      <p>
        We may disclose information where required by law, or where we believe in good faith that it
        is necessary to prevent serious harm.
      </p>
      <p>
        <strong>[TO BE COMPLETED]</strong> — name each provider, and confirm where each stores data.
        Counsel should review any cross-border transfer against the DPDP Act 2023.
      </p>

      <h2>5. How long we keep it</h2>
      <ul>
        <li>
          <strong>Chat messages</strong> — 90 days, then deleted, unless flagged in a safety report
        </li>
        <li>
          <strong>Session records</strong> — 12 months, then archived
        </li>
        <li>
          <strong>Financial records</strong> — retained as long as tax and accounting law requires
        </li>
        <li>
          <strong>Companion identity documents</strong> — retained after offboarding for the period
          financial regulations require
        </li>
      </ul>

      <h2>6. Your rights</h2>
      <p>You can ask us to:</p>
      <ul>
        <li>Show you what we hold about you</li>
        <li>Correct anything wrong</li>
        <li>Delete your account and personal data</li>
        <li>Explain how a decision affecting your account was made</li>
      </ul>
      <p>
        On deletion, we anonymise your profile.{' '}
        <strong>Financial ledger entries are retained</strong> against an anonymous identifier,
        because we are legally required to keep accurate financial records. Those entries no longer
        identify you.
      </p>
      <p>
        Make a request through our <a href="/contact">Contact page</a>. We respond within{' '}
        <strong>30 days</strong>.
      </p>

      <h2>7. Security</h2>
      <p>
        Traffic is encrypted in transit. Identity documents and bank details are encrypted at rest
        and reachable only by authorised staff, and every such access is logged.
      </p>
      <p>
        No system is perfectly secure. If a breach affects you, we will tell you and the relevant
        authority as the law requires.
      </p>

      <h2>8. Children</h2>
      <p>
        MakeMyPartner is strictly for adults aged 18 and over. We do not knowingly collect data from
        anyone under 18. If we learn that we have, we delete it and close the account.
      </p>

      <h2>9. Changes</h2>
      <p>
        We will notify you in the app before any material change takes effect. The date at the top
        of this page always reflects the current version.
      </p>

      <h2>10. Contact</h2>
      <p>
        Our Data Protection Officer and Grievance Officer details are on the{' '}
        <a href="/contact">Contact page</a>.
      </p>
    </LegalLayout>
  );
}
